export enum TimeZonesPlatformAccessOperation {
    create = "561bef32-68f5-4b5d-a30f-ce8f506c8cee",
    read = "6f1bf63a-2c08-4b0e-b3a6-99963e9741c5",
    update = "39a1e703-c5fa-4cec-85d1-8765ac0a98cd",
    delete = "badf5140-b396-46ef-ab16-dcb13f56b716",
}
